import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    maxWidth: 738,

    padding: '1.5rem',

    marginLeft: 'auto',
    marginRight: 'auto',

    backgroundColor: theme.colors.white,
});

export const title: TRuleWithTheme = () => ({
    '&.ant-typography': {
        marginBottom: '1em',

        fontSize: '1.5rem',
        lineHeight: 1.33,
    },
});
export const description: TRuleWithTheme = ({ theme }) => ({
    '&.ant-typography': {
        marginBottom: '1.5em',

        fontSize: '1rem',
        lineHeight: 1.5,
    },
});
